import React from 'react';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import 'react-table/react-table.css';
import { LinearProgress } from 'react-md';
import '../../../node_modules/react-md/dist/react-md.indigo-blue.min.css';
import 'bootstrap-datepicker/js/bootstrap-datepicker.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import Loader from '../../_components/loader';
import 'react-notifications/lib/notifications.css';
import { AdminUrls } from '../../network/config';
import './style.css';
import { removeData } from '../../store/action';
import { connect } from 'react-redux';

const CpdReport_Url = AdminUrls.ADMIN.CPDCOMPLIANTINFO;
const CpdYear_Url = AdminUrls.ADMIN.GETCPDYEARS;
const loadReport_Url = AdminUrls.COMMON.GETREPORTLIST;

class CpdReport extends React.Component {
  constructor() {
    super();
    this.yearChangeHandler = this.yearChangeHandler.bind(this);
    this.getCpdReport = this.getCpdReport.bind(this);
    this.loadCpdData = this.loadCpdData.bind(this);
    this.handleClickEye = this.handleClickEye.bind(this);
    this.getCpdYear = this.getCpdYear.bind(this);

    this.state = {
      year: new Date().getFullYear(),
      mainLoading: false,
      cpdCompliant: '',
      cpdCompliantPercentage: '',
      eightPlusHrRecorded: '',
      eightPlusHrRecordedPercentage: '',
      fifteenMinutesToThreeHrPercentage: '',
      fifteenMinutesToThreeHrRecorded: '',
      fourToFiveHrRecorded: '',
      fourToFiveHrRecordedPercentage: '',
      nonCPDCompliantPercentage: '',
      nonCPDCompliant: '',
      systemUsage: '',
      systemUsagePercentage: '',
      totalMembers: '',
      loadCpdReport: [],
      selectYear: new Date().getFullYear().toString(),
      emptyDivMsg: 'There is no data to show in the grid.',
      cpdYear: [],
    };
    this.controller = new AbortController();
  }

  componentDidMount() {
    this.loadCpdData();
    this.getCpdReport(this.state?.selectYear);
    this.getCpdYear();
  }

  compliantReport = (id) => {
    this.props.history.push(`/compliantreport/${id}`);
  };
  individualReport = () => {
    this.props.history.push({
      pathname: '/individualuserreport',
      state: +this.state?.selectYear,
    });
  };
  systemUsageReport = () => {
    this.props.history.push({
      pathname: '/systemusagereport',
      state: +this.state?.selectYear,
    });
  };
  yearChangeHandler(e) {
    this.setState({ selectYear: e.target.value });

    this.getCpdReport(e.target.value);
  }

  getCpdReport(years) {
    this.setState({
      mainLoading: true,
    });
    axios
      .get(CpdReport_Url, {
        params: {
          Year: years,
        },
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        let dup = response?.data;
        dup.map((item) =>
          this.setState({
            cpdCompliant: item?.CPDCompliant,
            cpdCompliantPercentage: item?.CPDCompliantPercentage,
            eightPlusHrRecorded: item?.EightPlusHrRecorded,
            eightPlusHrRecordedPercentage: item?.EightPlusHrRecordedPercentage,
            fifteenMinutesToThreeHrPercentage:
              item?.FifteenMinutesToThreeHrPercentage,
            fifteenMinutesToThreeHrRecorded:
              item?.FifteenMinutesToThreeHrRecorded,
            fourToFiveHrRecorded: item?.FourToFiveHrRecorded,
            fourToFiveHrRecordedPercentage:
              item?.FourToFiveHrRecordedPercentage,
            nonCPDCompliantPercentage: item?.NoNCPDCompliantPercentage,
            nonCPDCompliant: item?.NonCPDCompliant,
            systemUsage: item?.SystemUsage,
            systemUsagePercentage: item?.SystemUsagePercentage,
            totalMembers: item?.TotalMembers,
            mainLoading: false,
          })
        );
      })

      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  loadCpdData() {
    this.setState({
      mainLoading: true,
    });
    axios
      .get(loadReport_Url, {
        method: 'GET',
        withCredentials: true,
        credentials: 'include',
        signal: this.controller.signal,
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        this.setState({
          loadCpdReport: response?.data,
          mainLoading: false,
        });
      })

      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  handleClickEye(id) {
    if (id === 'CPD0001') {
      this.props.history.push({
        pathname: '/individualuserreport',
        state: +this.state?.selectYear,
      });
    }
    if (id === 'CPD0002' || id === 'CPD0003') {
      this.props.history.push(`/compliantreport/${id}`);
    }
    if (id === 'CPD0004') {
      this.props.history.push(`/randomreport`);
    }
    if (id === 'CPD0005') {
      this.props.history.push({
        pathname: '/systemusagereport',
        state: +this.state?.selectYear,
      });
    }

    if (id === 'CPD0006' || id === 'CPD0007' || id === 'CPD0008') {
      this.props.history.push(`/recordedzerohour/${id}`);
    }
    if (id === 'CPD0009') {
      this.props.history.push({
        pathname: '/affiliatereport',
        state: +this.state?.selectYear,
      });
    }
  }

  getCpdYear() {
    axios
      .get(CpdYear_Url, {
        method: 'GET',
        withCredentials: true,
        credentials: 'include',
        signal: this.controller.signal,
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        this.setState({
          cpdYear: response?.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }
  componentWillUnmount() {
    this.controller.abort();
  }

  render() {
    let loadCpdReport;

    if (this.state.loadCpdReport !== null) {
      loadCpdReport = this.state.loadCpdReport.map((cpdReportItem, index) => {
        return (
          <tr key={index}>
            <td>{cpdReportItem.ReportId}</td>
            <td>{cpdReportItem.ReportName}</td>
            <td>{cpdReportItem.ReportDescription}</td>
            <td>
              <button
                onClick={() => this.handleClickEye(cpdReportItem.ReportId)}
                className="button-custom"
              >
                <i className="fa fa fa-eye"> </i>
              </button>
            </td>
          </tr>
        );
      });
    }

    return (
      <div>
        {this.state.mainLoading && <LinearProgress id="main-loader" />}

        <div className="row">
          <div className="col-xs-6 select-cdpreport">
            Year
            <select
              className="select-cdpreport"
              value={this.state.selectYear}
              onChange={(e) => this.yearChangeHandler(e)}
              id="sel1"
            >
              {this?.state?.cpdYear &&
                this?.state?.cpdYear.map((item, index) => {
                  return (
                    <option value={item} key={index}>
                      {item}
                    </option>
                  );
                })}
            </select>
          </div>
        </div>

        <div className="row cdp">
          <div className="col-xs-12 col-sm-6 col-md-4">
            <div className="dashboard_box_cdp">
              <div className="pull-right green_icon_cdp">
                <i className="fa fa-graduation-cap"> </i>
              </div>
              {this.state?.cpdCompliantPercentage}% / {this.state?.cpdCompliant}
              <div className="white_progress_cdp">
                <div
                  className="white_progress_inner_cdp"
                  style={{ width: '100%' }}
                >
                  {' '}
                </div>
              </div>
              <div className="dashboard-box-footer_cdp" id="dashBox1">
                <div id="courseToDo">
                  <span>CPD Compliant</span>
                  <span style={{ float: 'right' }}>
                    {this?.state?.selectYear}{' '}
                    <button onClick={() => this.compliantReport('CPD0002')}>
                      <i className="fa fa-folder-open ng-scope"></i>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xs-12 col-sm-6 col-md-4">
            <div className="dashboard_box_cdp dashboard_blue">
              <div className="pull-right green_icon_cdp">
                <i className="fa fa-exclamation-circle"> </i>
              </div>
              {this.state?.nonCPDCompliantPercentage}% /{' '}
              {this.state?.nonCPDCompliant}
              <div className="white_progress_cdp">
                <div
                  className="white_progress_inner_cdp"
                  style={{ width: '100%' }}
                >
                  {' '}
                </div>
              </div>
              <div className="dashboard-box-footer_cdp" id="dashBox1">
                <div id="courseToDo">
                  <span>CPD Non Compliant</span>
                  <span style={{ float: 'right' }}>
                    {this?.state?.selectYear}{' '}
                    <button onClick={() => this.compliantReport('CPD0003')}>
                      <i className="fa fa-folder-open ng-scope"></i>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xs-12 col-sm-6 col-md-4">
            <div className="dashboard_box_cdp">
              <div className="pull-right green_icon_cdp">
                <i className="fa fa-trophy"> </i>
              </div>
              {this.state?.eightPlusHrRecordedPercentage}% /{' '}
              {this.state?.eightPlusHrRecorded}
              <div className="white_progress_cdp">
                <div
                  className="white_progress_inner_cdp"
                  style={{ width: '100%' }}
                >
                  {' '}
                </div>
              </div>
              <div className="dashboard-box-footer_cdp" id="dashBox1">
                <div id="courseToDo">
                  <span>8hr+ Recorded</span>
                  <span style={{ float: 'right' }}>
                    {this?.state?.selectYear}{' '}
                    <button onClick={this.individualReport}>
                      <i className="fa fa-folder-open ng-scope"></i>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xs-12 col-sm-6 col-md-4">
            <div className="dashboard_box_cdp dashboard_blue">
              <div className="pull-right green_icon_cdp">
                <i className="fa fa-desktop"> </i>
              </div>
              {this.state?.systemUsagePercentage}% / {this.state?.systemUsage}
              <div className="white_progress_cdp">
                <div
                  className="white_progress_inner_cdp"
                  style={{ width: '100%' }}
                >
                  {' '}
                </div>
              </div>
              <div className="dashboard-box-footer_cdp" id="dashBox1">
                <div id="courseToDo">
                  <span>System Usage</span>
                  <span style={{ float: 'right' }}>
                    {this?.state?.selectYear}{' '}
                    <button onClick={this.systemUsageReport}>
                      <i className="fa fa-folder-open ng-scope"></i>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xs-12 col-sm-6 col-md-4">
            <div className="dashboard_box_cdp">
              <div className="pull-right green_icon_cdp">
                <i className="fa fa-clock-o"> </i>
              </div>
              {this.state?.fifteenMinutesToThreeHrPercentage}% /{' '}
              {this.state?.fifteenMinutesToThreeHrRecorded}
              <div className="white_progress_cdp">
                <div
                  className="white_progress_inner_cdp"
                  style={{ width: '100%' }}
                >
                  {' '}
                </div>
              </div>
              <div className="dashboard-box-footer_cdp" id="dashBox1">
                <div id="courseToDo">
                  <span>Recorded 15m-3hr</span>
                  <span style={{ float: 'right' }}>
                    {this?.state?.selectYear}{' '}
                    <button onClick={this.individualReport}>
                      <i className="fa fa-folder-open ng-scope"></i>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xs-12 col-sm-6 col-md-4">
            <div className="dashboard_box_cdp dashboard_blue">
              <div className="pull-right green_icon_cdp">
                <i className="fa fa-clock-o"> </i>
              </div>
              {this.state?.systemUsagePercentage}% / {this.state?.systemUsage}
              <div className="white_progress_cdp">
                <div
                  className="white_progress_inner_cdp"
                  style={{ width: '100%' }}
                >
                  {' '}
                </div>
              </div>
              <div className="dashboard-box-footer_cdp" id="dashBox1">
                <div id="courseToDo">
                  <span>Recorded 4h-5hr</span>
                  <span style={{ float: 'right' }}>
                    {this?.state?.selectYear}{' '}
                    <button onClick={this.individualReport}>
                      <i className="fa fa-folder-open ng-scope"></i>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-table-cdp">
          {this.state.mainLoading && <Loader />}
          <table className="table table-striped table-bordered table-hover table-condensed">
            <thead>
              <tr className="header">
                <th>Report ID</th>
                <th>Report Name</th>
                <th>Report Description</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>{loadCpdReport}</tbody>
          </table>
          {loadCpdReport.length > 0 ? '' : this.state.emptyDivMsg}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(removeData()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CpdReport));
